import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "overview"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#example4" }),
  /*#__PURE__*/_createTextVNode(" Validation schemas with yup ")
], -1)
const _hoisted_3 = { class: "py-5" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Fortunately there is already a very neat way to build validation schemas for your forms by using "),
  /*#__PURE__*/_createVNode("b", null, "yup"),
  /*#__PURE__*/_createTextVNode(", it allows you create validation objects like this: ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" vee-validate has built-in support for yup schemas, You can pass your schemas to the "),
  /*#__PURE__*/_createVNode("b", null, "useForm"),
  /*#__PURE__*/_createTextVNode(" function using the same "),
  /*#__PURE__*/_createVNode("b", null, "validationSchema"),
  /*#__PURE__*/_createTextVNode(" option: ")
], -1)
const _hoisted_6 = { class: "rounded border p-10" }
const _hoisted_7 = { class: "mb-10" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", {
  for: "emailField",
  class: "form-label"
}, "Email address", -1)
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  for: "passwordField",
  class: "form-label"
}, "Password", -1)
const _hoisted_11 = { class: "text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")
  const _component_CodeHighlighter2 = _resolveComponent("CodeHighlighter2")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_CodeHighlighter, { lang: "js" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.example4Js1), 1)
        ]),
        _: 1
      }),
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createVNode("input", {
            type: "email",
            name: "email",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
            class: "form-control form-control-solid",
            id: "emailField",
            placeholder: "email"
          }, null, 512), [
            [_vModelText, _ctx.email]
          ]),
          _createVNode("span", _hoisted_9, _toDisplayString(_ctx.emailError), 1)
        ]),
        _hoisted_10,
        _withDirectives(_createVNode("input", {
          type: "password",
          name: "password",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event)),
          class: "form-control form-control-solid",
          id: "passwordField",
          placeholder: "password"
        }, null, 512), [
          [_vModelText, _ctx.password]
        ]),
        _createVNode("span", _hoisted_11, _toDisplayString(_ctx.passwordError), 1),
        _createVNode(_component_CodeHighlighter2, null, {
          html: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.example4Html), 1)
          ]),
          js: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.example4Js2), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}